module.exports = __webpack_public_path__ + "img/tmf_management.c0398a23.png";